<div class="warnings" *ngIf="warningMessage$ | async">
  <p class="alert alert-warning">{{ warningMessage$ | async }}</p>
</div>
